import { PropsWithChildren, TdHTMLAttributes } from 'react';
import { TableCell, TableRow, cn } from '@sib/ui';

export interface DataTableNoResultsRowProps
  extends TdHTMLAttributes<HTMLTableCellElement> {}

export const DataTableNoResultsRow = ({
  width,
  children,
  colSpan,
  className,
  ...props
}: PropsWithChildren<DataTableNoResultsRowProps>) => (
  <TableRow className="hover:bg-white">
    <TableCell
      {...props}
      colSpan={colSpan}
      className={cn('overflow-visible text-center', className)}
    >
      <div style={{ width }} className="sticky left-0 z-10 bg-white px-4 py-1">
        {children}
      </div>
    </TableCell>
  </TableRow>
);
